module.exports = __webpack_public_path__ + "static/media/wifiqube-1.215eb7ff.jpg";